module.exports = __webpack_public_path__ + "static/media/geupsikpage.d650a821.png";